import Cookies from 'js-cookie'

document.addEventListener('DOMContentLoaded', function () {
    const presalePopup = document.getElementById('presale-popup');
    if (presalePopup) {
        // Check if the user has already closed the popup
        if (!Cookies.get('tickets_presale_popup_closed')) {
            presalePopup.showModal();
        }

        // Close modal
        jQuery(document).on('click', '.presale-popup__close', function () {
            var dialog = jQuery(this).closest('dialog')[0];
            // Set cookie when user explicitly closes the modal
            Cookies.set('tickets_presale_popup_closed', 'true', { expires: 7 }); // Cookie expires in 7 days
            dialog.setAttribute('closing', '');
            dialog.addEventListener('animationend', function () {
                dialog.removeAttribute('closing');
                dialog.close();
            }, { once: true });
        });
        // Optional: Close the modal when clicking outside of it
        jQuery(document).on('click', 'dialog', function (event) {
            if (event.target.nodeName === 'DIALOG') {
                var dialog = event.target;
                // Set cookie when user clicks outside to close
                Cookies.set('tickets_presale_popup_closed', 'true', { expires: 7 }); // Cookie expires in 7 days
                dialog.setAttribute('closing', '');
                dialog.addEventListener('animationend', function () {
                    dialog.removeAttribute('closing');
                    dialog.close();
                }, { once: true });
            }
        });
    }
});